'use client';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function Footer() {
  const pathname = usePathname();

  const footerLinkStyle =
    'inline-flex leading-none no-underline text-[#000] flex items-center will-change-[opacity] outline-0 hover-animation';

  // フッターの表示判定
  const excludedPaths = [
    '/', // サービスページ
    '/ranking',
    '/value',
    '/diagnostic',
    '/registration-entry'
  ];

  const isDisplay =
    !excludedPaths.includes(pathname) && !pathname.startsWith('/register');

  return (
    <>
      {isDisplay ? (
        <footer className="border-t border-solid border-[#ddd] px-[16px] pb-[30px] pt-[32px] font-yu md:px-0 md:pt-[20px]">
          <nav>
            <ul className="flex flex-col gap-[20px] md:flex-row md:items-center md:justify-center md:gap-0">
              <li className="mr-[44px] text-[14px]">
                <a
                  href="https://assign-inc.com/view"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footerLinkStyle}
                >
                  <Image
                    className="mr-[8px] align-middle"
                    src="/static/images/icons/footer/about.svg"
                    alt="アサインとは"
                    width={22}
                    height={22}
                  />
                  ASSIGN TECHとは？
                </a>
              </li>
              <li className="ml-[3px] mr-[44px] text-[14px] md:ml-0">
                <a
                  href="https://assign-inc.com/engineer-privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footerLinkStyle}
                >
                  <Image
                    className="mr-[8px] align-middle"
                    src="/static/images/icons/footer/policy.svg"
                    alt="プライバシーポリシー"
                    width={18}
                    height={22}
                  />
                  プライバシーポリシー
                </a>
              </li>
              <li className="ml-[3px] mr-[44px] text-[14px] md:ml-0">
                <a
                  href="https://assign-inc.com/engineer-terms-of-use/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footerLinkStyle}
                >
                  <Image
                    className="mr-[8px] align-middle"
                    src="/static/images/icons/footer/terms.svg"
                    alt="利用規約"
                    width={18}
                    height={22}
                  />
                  利用規約
                </a>
              </li>
              <li className="text-[14px]">
                <Link href="/inquiry" className={footerLinkStyle}>
                  <Image
                    className="mr-[8px] align-middle"
                    src="/static/images/icons/footer/inquiry.svg"
                    alt="お問い合わせ"
                    width={22}
                    height={22}
                  />
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </nav>
          <small className="mt-[32px] block text-[14px] text-[#989898] md:mt-[40px] md:text-center">
            &copy; ASSIGN Inc. All Right Reserved
          </small>
        </footer>
      ) : (
        <></>
      )}
    </>
  );
}
